<template>
  <div>
    <gridTable style="padding: 12px 0" :columns="baseInfoColumns" :data-list="info.baseDataList"></gridTable>
    <div v-for="(item,index) in otherInfo" :key="index">
      <gridTable style="padding-bottom: 12px;" :columns="otherInfoColumns" :data-list="item.otherDataList"></gridTable>
      <gridTable style="padding-bottom: 12px;" :columns="[...item.otherInfoColumns2, ...totalColums]" :data-list="item.otherDataList2"></gridTable>
      <gridTable v-show="index == otherInfo.length -1" style="padding-bottom: 12px; width: 380px;" :columns="item.totalColumnsList" :data-list="item.totalDataList"></gridTable>
    </div>
  </div>
</template>

<script>
  import gridTable from "./common/grid-table";

  const activeBGColor = {
    // background: 'rgba(255,255,128,.5) !important',
  }
  export default {
    name: "print-content",
    components: {
      gridTable
    },
    props: {
      info: {
        type: Object,
        default: () => {
        }
      },
      otherInfo: {
        type: Array,
        default: () => []
      },

    },
    data() {
      return {
        totalColums: [
          {
            label: "Total",
            property: "totalQuantity",
          }
        ],
        baseInfoColumns: [
          {
            "label": "SUPPLIER",
            "property": "vendorCode",
            style: activeBGColor
          }, {
            "label": "ORDER NO",
            "property": "sapPoNo",
            style: activeBGColor
          }, {
            "label": "YEAR-SEASON",
            "property": "fixedText",
            style: activeBGColor
          }, {
            "label": "COO",
            "property": "sourceArea",
            style: activeBGColor
          }, {
            "label": "Destination",
            "property": "poArea",
            style: activeBGColor
          }
        ],
        otherInfoColumns: [
          {
            "label": "Order date",
            "property": "createdDate",
            style: activeBGColor
          }, {
            "label": "Item",
            "property": "poItemCode",
            style: activeBGColor
          }, {
            "label": "Colour",
            "property": "colorDescEn",
            style: activeBGColor
          }, {
            "label": "Description",
            property: 'description',
            style: activeBGColor
          }, {
            "label": "DEL",
            property: 'waveCode',
            style: activeBGColor
          }, {
            "label": "Delivery Required",
            "property": "deliveryDate",
            style: activeBGColor
          }, {
            "label": "Currency",
            "property": "currency",
            style: activeBGColor
          }, {
            "label": "Unit Price",
            "property": "price",
            style: activeBGColor
          }
        ],
        
        totalInfoColumns: [{
          "label": "FINAL TOTAL",
          "property": "",
        }, {
          "label": "108",
          "property": "",
        }, {
          "label": "3132.00",
          "property": "",
        },]
      }
    },
    computed: {
    }
  }
</script>

<style scoped lang="scss">

</style>